import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findDepositRecharge= (params) => {
    params.rechargeClientType='JOINS_AGENT'
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/pledge?`+params,
        method: 'GET'
    })
}
export const getPledgeType= () => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_recharge/getPledgeType`,
        method: 'GET'
    })
}
export const addPledge= (data) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/pledge`,
        method: 'POST',
        data: data
    })
}
export const wxNativePayQuery= (outTradeNo) => {
    return request({
        url: `${baseUrl}/joins-pay/wx_native_pay_query/${outTradeNo}`,
        method: 'GET',
        timeout:1000 * 120
    })
}